<style scoped lang="less">
  @import './choose.less';
</style>
<style lang="less">
  @import './chooseScoped.less';
</style>
<template>
  <el-dialog class="my-el-dialogs" custom-class="dialog-choose-what" :visible.sync="is_show" :close-on-click-modal="false" :width="configWidth+'px'">
    <div class="choosePersonType">
      <template v-if="config.showtab=='org'||config.showtab==''">
        <a href="javascript:;" :class="{active:choosePersonType==true}" @click="organizationChoosePerson">{{config.orgcaption}}</a>
      </template>
      <!--<template v-if="config.showtab=='social'||config.showtab==''">-->
      <!--<a href="javascript:;" @click="socialCircleChoosePerson" :class="{active:choosePersonType==false}">{{config.socialcaption}}</a>-->
      <!--</template>-->
    </div>
    <div class="choose_main">
      <div class="choose_left">
        <div class="treeBox">
          <template v-if="config.showtab=='org'||config.showtab==''">
            <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="width: 175px">
            </el-input>
            <el-tree ref="orgTree" :data="orgData" node-key="id" :filter-node-method="filterNode" :highlight-current="true" :default-expanded-keys="defaultExpandedOrgFirstLeve" :expand-on-click-node="false" @node-click="setCurrentNode" :props="orgDefaultProps" class="display_no" style="overflow: hidden;border: none">
            </el-tree>
          </template>
        </div>
      </div>
      <div class="choose_right">
        <div class="choose_list">
          <div class="seach_box">
            <div class="seach">
              <div class="el-input el-input-group el-input-group--append">
                <input type="text" placeholder="请输入内容" autocomplete="off" @keyup.13="search" v-model="input5" class="el-input__inner">
                <div class="el-input-group__append">
                  <button type="button" @click="search" class="el-button el-button--default">
                    <i class="el-icon-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <el-checkbox v-model="isIncludeChild" style="margin-top: 8px;margin-left: 10px;" @change="includeChild">是否包含下级机构</el-checkbox>
          </div>
          <div style="padding: 10px 20px 0px 20px">
            <el-table :data="searchArea.tableData.aaData" v-loading="loading" element-loading-text="拼命加载中" ref="multipleTable" @select="handleSelectionChange" @select-all="allselect" :height="ht" class="org_table">
              <el-table-column type="selection">
              </el-table-column>
              <el-table-column label="机构名称" show-overflow-tooltip align="center">
                <template slot-scope="aa">
                  <template>{{aa.row.orgName}}</template>
                </template>
              </el-table-column>
              <el-table-column label="级别" width="100" show-overflow-tooltip>
                <template slot-scope="aa">
                  <template v-if="aa.row.orgGrade==1">校区</template>
                  <template v-if="aa.row.orgGrade==2">中心校</template>
                  <template v-if="aa.row.orgGrade==3">县/区</template>
                  <template v-if="aa.row.orgGrade==4">市</template>
                  <template v-if="aa.row.orgGrade==5">省</template>
                </template>
              </el-table-column>
              <el-table-column label="机构名称路径" show-overflow-tooltip align="center">
                <template slot-scope="aa">
                  <template>{{aa.row.orgNamePath}}</template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="check_info" :style="'width:'+leftWidth+'px'">
          <div class="selected-personnel">已选机构({{personList.length}})
            <i class="el-icon-delete" @click="clearAll"></i>
          </div>

          <ul class="person_list">
            <template v-for="(pn,index) in personList">
              <li>
                <a href="javascript:;" :title="pn.orgName">
                  <span>{{pn.orgName}}</span>
                  <i class="el-icon-close" @click="unChoose(pn,index)"></i>
                </a>
              </li>
            </template>
          </ul>
        </div>
        <div class="footer">
          <template v-if="choosePersonType==true">
            <el-pagination
            @current-change="tableQuery.page = $event, search()"
            :total="searchArea.tableData.iTotalRecords"
            :page-size="length" layout="->, prev, pager, next">
            </el-pagination>
          </template>
          <template v-if="choosePersonType==false">
            <el-pagination
            @current-change="circleTableQuery.page = $event, search()"
            :total="searchArea.tableData.iTotalRecords"
            layout="->, prev, pager, next">
            </el-pagination>
          </template>
          <el-button type="primary" @click="config.confirm(personList),is_show = false">确定(已选{{personList.length}} 个)
          </el-button>
          <el-button @click="is_show = false">取消</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      filterText: "",
      page: 1,
      length: 10,
      loading: true,
      is_show: false,
      nowLeft: {},
      currentNode: {},
      input5: "",
      defaultExpandedOrgFirstLeve: [],
      defaultExpandedCircleFirstLeve: [],
      isA: false,
      isAs: false,
      choosePersonType: "",
      isCutPage: false,
      isIncludeChild: true,
      tableQuery: {
        page: 1,
        size: 10,
        draw: 0,
        filter: {
          orgId: "",
          keyWords: "",
          isIncludeChild: "",
          status: ""
        },
        order: {}
      },
      ht: "480",
      circleTableQuery: {
        page: 1,
        length: 2,
        draw: 0,
        filter: {
          gradationId: "",
          schoolId: "",
          gradeId: "",
          courseId: "",
          roleCode: "",
          pinYin: "",
          groupId: "",
          keyWord: ""
        }
      },
      letterList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      primary_A: "primary",
      primary_B: "primary",
      primary_C: "primary",
      primary_D: "primary",
      primary_E: "primary",
      section: [],
      sectionid: "",
      grade: [],
      b: [],
      gradeid: "",
      subject: [],
      subjectid: "",
      school: [],
      schoolid: "",
      pinYin: "",
      groupId: "",
      role: [
        { key: "teacher", value: "教师" },
        { key: "student", value: "学生" },
        { key: "patriarch", value: "家长" }
      ],
      roleid: "",
      config: {
        caption: "选择控件",
        multi: true,
        confirm: function() {},
        left: [],
        selected: [],
        right: {
          waiting: {
            conditionList: [],
            columnList: []
          },
          selected: {
            getInfoUrl: "",
            conditionList: [],
            columnList: []
          }
        }
      },
      treeDefine: "",
      orgData: [],
      circleData: [],
      searchArea: {
        tableQuery: {
          page: 1,
          length: 2,
          draw: 0,
          order: "",
          filter: {
            isIncludeChild: 0,
            keywords: "",
            orgId: ""
          }
        },
        tableData: {
          aaData: [],
          draw: 0,
          iTotalDisplayRecords: 0,
          iTotalRecords: 0
        }
      },
      resultArea: {
        tableQuery: {
          page: 1,
          length: 2,
          draw: 0,
          order: "",
          filter: {
            isIncludeChild: 0,
            keywords: "",
            orgId: ""
          }
        },
        tableData: {
          aaData: [],
          draw: 0,
          iTotalDisplayRecords: 0,
          iTotalRecords: 0
        }
      },
      personList: [],
      selectedData: [],
      selectedAllData: [],
      configWidth:'1000',
      leftWidth:'220'
    };
  },
  created() {
    Array.prototype.unique1 = function() {
      var res = [this[0]];
      for (var i = 1; i < this.length; i++) {
        var repeat = false;
        for (var j = 0; j < res.length; j++) {
          if (this[i].id == res[j].id) {
            repeat = true;
            break;
          }
        }
        if (!repeat) {
          res.push(this[i]);
        }
      }
      return res;
    }; //去重
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    setCurrentNode(node) {
      let vm = this;
      this.currentNode = node;
      //        vm.b = [];
      //        console.log(node)
      //        vm.b.push({name: node.orgName, id: node.id});
      //        vm.ss(node.children);
      this.search();
    },
    //      ss(v) {
    //        let vm = this;
    //        _.forEach(v, function (n) {
    //          vm.b.push({name: n.orgName, id: n.id})
    //          if (n.children) {
    //            _.forEach(n.children, function (s) {
    //              vm.b.push({name: s.orgName, id: s.id})
    //              if (s.children) {
    //                vm.ss(s.children);
    //              }
    //            })
    //          }
    //        })
    //      },
    unChoose(pn, index) {
      let vm = this;
      let ii = vm.personList[index];
      var n = vm.personList.length;
      for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
        if (ii.id == vm.searchArea.tableData.aaData[j].id) {
          vm.searchArea.tableData.aaData[j].querySelected = false;
          vm.$nextTick(function() {
            vm.$refs.multipleTable.toggleRowSelection(
              vm.searchArea.tableData.aaData[j],
              false
            );
          });
        }
      }
      for (var j = 0; j < n; j++) {
        //删除缓存结果数据
        if (vm.personList[j].id == ii.id) {
          vm.personList.splice(j, 1);
          n = n - 1;
        }
      }
      let d = vm.selectedData.length;
      for (var g = 0; g < d; g++) {
        //删除中间缓存数据
        if (vm.selectedData[g].id == pn.id) {
          vm.selectedData.splice(g, 1);
          d = d - 1;
        }
      }
    },
    clearAll() {
      let vm = this;
      vm.selectedData = [];
      vm.personList = [];
      vm.search();
    },
    includeChild() {
      this.search();
    },
    search() {
      let vm = this;
      vm.loading = true;
      vm.tableQuery.filter.keyWords = vm.input5;
      vm.tableQuery.filter.orgId = vm.currentNode.id ? vm.currentNode.id : "";
      vm.tableQuery.filter.isIncludeChild = vm.isIncludeChild ? 1 : 0;
      vm.tableQuery.filter.status = "";
      //        if(vm.initialParamss.length>0){
      //          _.forEach(vm.initialParamss,function(v){
      //            _.forIn(v,function(val,key){
      //              vm.tableQuery.filter[key]=val;
      //            })
      //          })
      //        }
      let obj = $.extend({}, vm.tableQuery, {
        filter: eduFilterParam(vm.tableQuery.filter)
      });
      http
        .get(InterfacePrefix['platform'] + "/orgs/list", { params: obj })
        .then(function(xhr) {
          _.each(xhr.data.aaData, function(vv) {
            vv.querySelected = false;
            vv.deSelected = false;
          });
          vm.searchArea.tableData = xhr.data;
          //  vm.searchArea.tableData.aaData = _.chunk((vm.b), vm.length)[vm.page - 1];
          vm.$nextTick(function() {
            for (let i = 0; i < vm.personList.length; i++) {
              //回显
              for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
                if (
                  vm.personList[i].id == vm.searchArea.tableData.aaData[j].id
                ) {
                  vm.searchArea.tableData.aaData[j].querySelected = true;
                  vm.$refs.multipleTable.toggleRowSelection(
                    vm.searchArea.tableData.aaData[j],
                    true
                  );
                }
              }
            }
          });
          setTimeout(() => {
            vm.loading = false;
          }, 500);
        });
    },
    allselect(val) {
      let vm = this;
      let el = true;
      if (val.length > 0) {
        _.each(vm.searchArea.tableData.aaData, function(vv) {
          vv.querySelected = true;
          vm.handleSelectionChange(el, vv, 1);
        });
      } else {
        _.each(vm.searchArea.tableData.aaData, function(vv) {
          vv.querySelected = false;
          vm.handleSelectionChange(el, vv, 2);
        });
      }
    },
    handleSelectionChange(e, v, s) {
      let vm = this;
      let checked = e == true ? e : !v.querySelected;
      if (s) {
        s == 1 ? (checked = true) : (checked = false);
      }
      if (checked) {
        //是否勾选
        for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
          if (v.id == vm.searchArea.tableData.aaData[j].id) {
            vm.searchArea.tableData.aaData[j].querySelected = true;
            vm.$nextTick(function() {
              vm.$refs.multipleTable.toggleRowSelection(
                vm.searchArea.tableData.aaData[j],
                true
              );
            });
          }
        }
      }
      let list = _.filter(vm.searchArea.tableData.aaData, function(vv) {
        return vv.querySelected;
      });
      if (checked) {
        //是否勾选
        let b = [];
        if (list.length != 0) {
          let aa = list.length;
          for (var j = 0; j < aa; j++) {
            //合并数据
            vm.selectedData.push(list[j]);
          }
        }
        b = vm.selectedData;
        if (vm.selectedData.length > 1) {
          vm.selectedData = b.unique1();
        } else {
          vm.selectedData = b;
        }
      } else {
        for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
          if (v.id == vm.searchArea.tableData.aaData[j].id) {
            vm.searchArea.tableData.aaData[j].querySelected = false;
            vm.$nextTick(function() {
              vm.$refs.multipleTable.toggleRowSelection(
                vm.searchArea.tableData.aaData[j],
                false
              );
            });
          }
        }
        let s = vm.selectedData.length;
        for (var h = 0; h < s; h++) {
          //删除中间缓存数据
          if (vm.selectedData[h].id == v.id) {
            vm.selectedData.splice(h, 1);
            s = s - 1;
            h = h - 1;
          }
        }
      }
      if (vm.selectedData.length > 1) {
        vm.personList = vm.selectedData.unique1();
      } else {
        vm.personList = vm.selectedData;
      }
    },
    organizationChoosePerson() {
      this.choosePersonType = true;
      this.isA ? (this.ht = "308") : (this.ht = "480");
      this.getTreeData();
      this.search();
      this.isIncludeChild = true;
    },
    query() {},
    getTreeData() {
      let vm = this;
      let val = vm.treeDefine;
      let orgurl = val.orgTreeUrl;
      http.get(orgurl).then(function(xhr) {
        vm.orgData = [];
        vm.defaultExpandedOrgFirstLeve = [];
        vm.defaultExpandedOrgFirstLeve.push(xhr.data.data[0].id);
        vm.currentNode = xhr.data.data[0];
        vm.orgData = xhr.data.data;
        vm.search();
      });
    }
  },
  computed: {
    orgDefaultProps() {
      return {
        children: "children",
        label: this.nowLeft.displayKey
      };
    },
    circleDefaultProps() {
      return {
        children: "children",
        label: this.nowLeft.displayKeys
      };
    }
  },
  watch: {
    filterText(val) {
      this.$refs.orgTree.filter(val);
    },
    nowLeft(val) {
      let vm = this;
      vm.treeDefine = val;
      vm.getTreeData();
      vm.query();
    },
    config(val) {
      let vm = this;
      vm.personList = [];
      _.each(val.seletedData, function(vv) {
        vv.querySelected = true;
      });
      vm.personList = val.seletedData;
      vm.selectedData = val.seletedData;
      if(val.width){
        vm.configWidth = val.width
      }
      if(val.leftWidth){
        vm.leftWidth = val.leftWidth
      }
      if (val.showtab == "org" || val.showtab == "") {
        this.choosePersonType = true;
      }
      if (val.showtab == "social") {
        this.choosePersonType = false;
      }
      this.nowLeft = val.left[0];
    },
    is_show(val) {
      let vm = this;
      if (val) {
        this.searchArea = {
          tableQuery: {
            page: 1,
            length: 10,
            draw: 0,
            order: "",
            filter: {
              isIncludeChild: 0,
              keywords: "",
              status: "",
              selected: [],
              orgId: ""
            }
          },
          tableData: {
            aaData: [],
            draw: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0
          }
        };
        this.resultArea = {
          tableQuery: {
            page: 1,
            length: 10,
            draw: 0,
            order: "",
            filter: {
              isIncludeChild: 0,
              keywords: "",
              status: "",
              orgId: ""
            }
          },
          tableData: {
            aaData: [],
            draw: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0
          }
        };
        let ids = this.config.selected.map(function(vv) {
          return vv.id;
        });
        ids.length &&
          http
            .post(this.config.right.selected.getInfoUrl, ids)
            .then(function(xhr) {
              // vm.resultArea.tableData = xhr.data.data
              vm.resultArea.tableData.iTotalRecords = xhr.data.data.length;
              vm.resultArea.tableData.aaData = xhr.data.data;
            });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/commonplugin/choose/chooseOrg.vue